/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils
import { isLight } from 'utils/theme'

const typefaceOptions = {
  DECORATIVE_AND_PLAIN: {
    SYSTEM: {
      header: 'serif',
      body: 'sans-serif'
    },
    HIGH_FIDELITY: {
      header: '"Source Serif Pro",serif',
      body: '"Work Sans", sans-serif'
    }
  },
  DECORATIVE: {
    SYSTEM: {
      header: 'serif',
      body: 'serif'
    },
    HIGH_FIDELITY: {
      header: '"Source Serif Pro",serif',
      body: '"Source Serif Pro",serif',
    }
  },
  PLAIN: {
    SYSTEM: {
      header: 'sans-serif',
      body: 'sans-serif'
    },
    HIGH_FIDELITY: {
      header: '"Work Sans", sans-serif',
      body: '"Work Sans", sans-serif'
    }
  },
}

const postedTimeSizeOptions = {
  SMALL: '12px',
  MEDIUM: '14px',
  LARGE: '16px'
}

const sizeOptions = {
  SMALL: '14px',
  MEDIUM: '16px',
  LARGE: '18px'
}

const headerSizeOptions = {
  SMALL: '16px',
  MEDIUM: '18px',
  LARGE: '20px'
}

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - THEME PREVIEW : STYLES --------------- ++++++++++ */
export default theme => ({
  themepreview: {
    '& .previewconfig': {
      '& .content': {
        flexDirection: 'column',
        background: props => props.siteTheme.customBackgroundColor || '#FFF',
        color: props => isLight(props.siteTheme.customBackgroundColor) ? '#000000' : '#FFFFFF'
      }
    },
    '& .icons': {
      '&.neutral': {
        '& *[fill]:not(svg)': {
          fill: ({ themeColors }) => themeColors['neutrals.bodyText']
        }
      }
    },
    '& .commentsheader': {
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      paddingBottom: pxToEm(8),
      marginBottom: pxToEm(8),
      borderBottom: ({ themeColors }) => `2px solid ${themeColors['neutrals.bodyText']}`,
      '& > div': {
        width: 'auto'
      },
      '& svg': {
        flex: 'none'
      }
    },
    '& h1, & h3': {
      color: ({ themeColors }) => themeColors['neutrals.bodyText'],
    },
    '& h3': {
      fontFamily: ({ siteTheme }) => typefaceOptions[siteTheme.fontTypeface][siteTheme.useSystemFont ? 'SYSTEM' : 'HIGH_FIDELITY'].header || 'serif',
      fontSize: ({ siteTheme }) => headerSizeOptions[siteTheme.fontSize] || '18px',
      fontWeight: 600
    },
    '& p': {
      fontFamily: ({ siteTheme }) => typefaceOptions[siteTheme.fontTypeface][siteTheme.useSystemFont ? 'SYSTEM' : 'HIGH_FIDELITY'].body || 'sans-serif',
      fontSize: ({ siteTheme }) => sizeOptions[siteTheme.fontSize] || '16px',
      fontWeight: 400,
      textAlign: 'justify'
    },
    '& span': {
      fontFamily: ({ siteTheme }) => typefaceOptions[siteTheme.fontTypeface][siteTheme.useSystemFont ? 'SYSTEM' : 'HIGH_FIDELITY'].body || 'sans-serif'
    },
    '& h1': {
      fontFamily: ({ siteTheme }) => typefaceOptions[siteTheme.fontTypeface][siteTheme.useSystemFont ? 'SYSTEM' : 'HIGH_FIDELITY'].header || 'serif',
      fontSize: '24px',
      fontWeight: 600
    },
    '& .commentscount': {
      background: ({ themeColors }) => themeColors.backgroundPrimary,
      borderRadius: '24px',
      padding: '4px 8px',
      margin: '4px',
      position: 'relative',
      top: '-2px',
      fontSize: ({ siteTheme }) => postedTimeSizeOptions[siteTheme.fontSize] || '16px',
    },
    '& .sortdropdown': {
      display: 'flex',
      width: '140px !important',
      justifyContent: 'space-between',
      alignItems: 'center',
      border: ({ themeColors }) => `1px solid ${themeColors.outlinePrimary}`,
      borderRadius: '4px',
      padding: `0 ${pxToEm(8)}`,
      fontSize: '14px',
      fontWeight: 600,
      '& svg': {
        width: pxToEm(16),
        height: pxToEm(16)
      }
    },
    '& .commentbox': {
      display: 'flex',
      width: '100%',
      height: '100%',
      alignItems: 'flex-start',
      background: ({ themeColors }) => themeColors.backgroundSecondary || '#E7EAF7',
      borderRadius: pxToEm(8),
      padding: '16px',
      '& .commenttextarea': {
        width: '100%',
        paddingBottom: '24px',
        marginBottom: '8px',
        borderBottom: ({ themeColors }) => `2px solid ${themeColors.accent || '#5A74DD'}`
      },
      '& h1': {
        fontWeight: 400
      },
    },
    '& .commentwrapper': {
      paddingLeft: pxToEm(48),
      display: 'flex',
      flexDirection: 'column',
      '&.hasreply': {
        gap: pxToEm(16),
        marginLeft: pxToEm(20),
        paddingLeft: pxToEm(24),
        borderLeft: ({ themeColors }) => `2px solid ${themeColors.backgroundSecondary}`
      }
    },
    '& .replycaret': {
      position: 'absolute',
      marginTop: '60px',
      marginLeft: '12px',
      overflow: 'hidden',
      background: ({ siteTheme }) => siteTheme.customBackgroundColor,
      width: '20px',
      height: '20px',
      '& *[fill]:not(svg)': {
        fill: ({ themeColors }) => themeColors['neutrals.bodyText']
      }
    },
    '& .button': {
      padding: pxToEm(8),
      borderRadius: pxToEm(4),
      fontWeight: 600,
      fontSize: pxToEm(12),
      minHeight: '32px',
      maxHeight: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: ({ themeColors }) => themeColors.buttons.secondary.main.background, 
      color: ({ themeColors }) => themeColors.buttons.secondary.main.text
    },
    '& .postbutton': {
      background: ({ themeColors }) => themeColors.buttons.primary.disabled.background, 
      color: ({ themeColors }) => themeColors.buttons.primary.disabled.text,
      padding: '6px 10px',
      fontSize: '16px',
      width: 'auto'
    },
    '& .reply': {
      fontSize: pxToEm(12),
      minHeight: '32px',
      maxHeight: '32px',
      display: 'flex',
      alignItems: 'center'
    },
    '& .commentfooter': {
      marginTop: pxToEm(8)
    },
    '& .commentrichmedia': {
      '& *[fill]:not(svg)': {
        fill: ({ themeColors }) => themeColors.secondaryText
      }
    },
    '& .postedtime': {
      fontSize: ({ siteTheme }) => postedTimeSizeOptions[siteTheme.fontSize] || '14px',
      fontWeight: 400,
      color: ({ themeColors }) => themeColors['neutrals.gray.main']
    }
  }
});
